import React from "react";
import PropTypes from "prop-types";
import { Snackbar, Alert, AlertTitle, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import {
  Check as CheckIcon,
  Error as ErrorIcon,
  Close as CloseIcon,
} from "@mui/icons-material";

const StyledAlert = styled(Alert)(({ theme }) => ({
  width: "348px",
  marginTop: "12px",
  marginRight: "24px",
}));

const Q8Snackbar = ({ type = "default", title, message, open, onClose }) => {
  const getAlertProps = () => {
    switch (type) {
      case "success":
        return {
          severity: "success",
          icon: <CheckIcon />,
        };
      case "error":
        return {
          severity: "error",
          icon: <ErrorIcon />,
        };
      default:
        return {
          severity: "info",
          icon: null,
        };
    }
  };

  return (
    <Snackbar
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      autoHideDuration={5000} // Facoltativo: chiude automaticamente dopo 5s
    >
      <StyledAlert
        {...getAlertProps()}
        onClose={onClose}
        action={
          <IconButton size="small" onClick={onClose}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
      >
        <AlertTitle>{title}</AlertTitle>
        {message}
      </StyledAlert>
    </Snackbar>
  );
};

Q8Snackbar.propTypes = {
  type: PropTypes.oneOf(["default", "success", "error"]),
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

Q8Snackbar.defaultProps = {
  type: "default",
};

export default Q8Snackbar;
